"use client";

import { c as _c } from "react/compiler-runtime";
import { Close } from "@mui/icons-material";
import useIsMobile from "@/hooks/use-mobile";
import { useClubsFiltersOpenedStore, useClubsFiltersStore } from "@/stores/clubs-filters-store";
import ClubFilterFormatItem from "./ClubFilterFormatItem";
export default function ClubFilterFormat() {
  const $ = _c(19);
  const isMobile = useIsMobile();
  const format = useClubsFiltersStore(_temp);
  const filterFormatOpened = useClubsFiltersOpenedStore(_temp2);
  const setFiltersFormatOpened = useClubsFiltersOpenedStore(_temp3);
  const setFiltersClosed = useClubsFiltersOpenedStore(_temp4);
  const removeFormat = useClubsFiltersStore(_temp5);
  const formatToDisplay = format === "monthly" ? "Convivial" : format === "fortnightly" ? "D\xE9veloppement" : format === "weekly" && "Intense";
  const formatColor = format === "monthly" ? "bg-success2" : format === "fortnightly" ? "bg-warning2" : format === "weekly" && "bg-primary";
  const t0 = `relative w-[30%] ${isMobile ? "w-full" : "w-[30%]"}`;
  const t1 = `w-[100%] flex flex-col justify-center items-start border-grey hover:cursor-pointer 
          ${isMobile ? "border-t border-b py-4" : "border-l border-r px-4"}`;
  let t2;
  if ($[0] !== setFiltersFormatOpened) {
    t2 = () => setFiltersFormatOpened();
    $[0] = setFiltersFormatOpened;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <p className="font-bold">Format du club</p>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== format || $[4] !== formatColor || $[5] !== formatToDisplay || $[6] !== removeFormat || $[7] !== setFiltersClosed) {
    t4 = format ? <p className={`text-sm font-bold ${formatColor} rounded-full px-2 text-white flex flex-row gap-2 items-center`}>{formatToDisplay}<Close style={{
        width: "15px",
        height: "15px"
      }} onClick={e => {
        removeFormat("");
        setFiltersClosed();
        e.stopPropagation();
      }} /></p> : <p className="text-grey text-sm">Nombre de réunions par mois</p>;
    $[3] = format;
    $[4] = formatColor;
    $[5] = formatToDisplay;
    $[6] = removeFormat;
    $[7] = setFiltersClosed;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t1 || $[10] !== t2 || $[11] !== t4) {
    t5 = <div className={t1} onClick={t2}>{t3}{t4}</div>;
    $[9] = t1;
    $[10] = t2;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== filterFormatOpened) {
    t6 = filterFormatOpened && <div className="px-[5%]"><div className="absolute top-[70px] bg-white z-10 w-[90%] h-[auto] border border-light-grey rounded-[5px] shadow-md"><ClubFilterFormatItem color="success2" icon="ship" label="Convivial" description={"1 r\xE9union par mois"} value="monthly" /><ClubFilterFormatItem color="warning2" icon="train" label={"D\xE9veloppement"} description={"2 r\xE9unions par mois"} value="fortnightly" /><ClubFilterFormatItem color="primary" icon="rocket" label="Intense" description={"1 r\xE9union par semaine"} value="weekly" /></div></div>;
    $[13] = filterFormatOpened;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t0 || $[16] !== t5 || $[17] !== t6) {
    t7 = <div className={t0}>{t5}{t6}</div>;
    $[15] = t0;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  return t7;
}
function _temp5(state_3) {
  return state_3.setFormat;
}
function _temp4(state_2) {
  return state_2.setFiltersClosed;
}
function _temp3(state_1) {
  return state_1.setFilterFormatOpened;
}
function _temp2(state_0) {
  return state_0.formatOpened;
}
function _temp(state) {
  return state.format;
}